module.exports = __webpack_public_path__ + "static/media/CTDWhite.c78c0d22.png";